import hrHR from "antd/lib/locale/hr_HR";
import enUS from "antd/lib/locale/en_US";
import deDE from "antd/lib/locale/de_DE";
import itIT from "antd/lib/locale/it_IT";
import {locales} from "../i18n";

const antdLocales = {
    "hr-HR": hrHR,
    "en-US": enUS,
    "de-DE": deDE,
    "it-IT": itIT,
};

export const resolveAntdLocale = (language?: string) => {
    const normalizedLanguage = language?.split("-")[0] ?? "hr";
    const localeKey = locales[normalizedLanguage] ?? locales.hr;

    return antdLocales[localeKey as keyof typeof antdLocales] ?? hrHR;
};
